import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card shadow-lg border-0" }
const _hoisted_5 = {
  class: "card-header text-white py-3",
  style: {"background-color":"#3e5fce"}
}
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = {
  class: "badge bg-white px-3 py-2",
  style: {"color":"#3e5fce"}
}
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = {
  class: "filter-section p-4 mb-4 bg-white rounded-3 shadow-sm",
  style: {"border":"2px solid #3e5fce"}
}
const _hoisted_11 = { class: "row g-3" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "action-buttons-section mb-4" }
const _hoisted_25 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "card-body p-4" }
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_33 = { class: "card-title text-dark mb-0" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "row g-3" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_38 = { class: "stat-item" }
const _hoisted_39 = { class: "stat-value badge bg-primary" }
const _hoisted_40 = { class: "stat-item" }
const _hoisted_41 = { class: "stat-value badge bg-success" }
const _hoisted_42 = { class: "stat-item" }
const _hoisted_43 = { class: "stat-value badge bg-danger" }
const _hoisted_44 = { class: "stat-item" }
const _hoisted_45 = { class: "stat-value badge bg-warning text-dark" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_48 = { class: "stat-item" }
const _hoisted_49 = { class: "stat-value text-primary fw-bold" }
const _hoisted_50 = { class: "stat-item" }
const _hoisted_51 = { class: "stat-value text-success fw-bold" }
const _hoisted_52 = { class: "stat-item" }
const _hoisted_53 = { class: "stat-value text-danger fw-bold" }
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_56 = { class: "stat-item" }
const _hoisted_57 = { class: "stat-value badge bg-warning text-dark" }
const _hoisted_58 = { class: "stat-item" }
const _hoisted_59 = { class: "stat-value text-info fw-bold" }
const _hoisted_60 = { class: "stat-item" }
const _hoisted_61 = { class: "stat-value" }
const _hoisted_62 = {
  class: "progress",
  style: {"height":"20px"}
}
const _hoisted_63 = ["aria-valuenow"]
const _hoisted_64 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_65 = { class: "table-responsive" }
const _hoisted_66 = { class: "table table-hover table-striped align-middle" }
const _hoisted_67 = { class: "fw-semibold" }
const _hoisted_68 = {
  class: "fw-bold",
  style: {"color":"#3e5fce"}
}
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "card-body p-4" }
const _hoisted_71 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_72 = { class: "card-title text-dark mb-0" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "row g-3" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_77 = { class: "stat-item" }
const _hoisted_78 = { class: "stat-value badge bg-primary" }
const _hoisted_79 = { class: "stat-item" }
const _hoisted_80 = { class: "stat-value badge bg-info" }
const _hoisted_81 = { class: "stat-item" }
const _hoisted_82 = { class: "stat-value badge bg-success" }
const _hoisted_83 = { class: "stat-item" }
const _hoisted_84 = { class: "stat-value badge bg-danger" }
const _hoisted_85 = { class: "stat-item" }
const _hoisted_86 = { class: "stat-value badge bg-warning text-dark" }
const _hoisted_87 = { class: "col-md-6" }
const _hoisted_88 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_89 = { class: "stat-item" }
const _hoisted_90 = { class: "stat-value text-primary fw-bold" }
const _hoisted_91 = { class: "stat-item" }
const _hoisted_92 = { class: "stat-value text-success fw-bold" }
const _hoisted_93 = { class: "stat-item" }
const _hoisted_94 = { class: "stat-value text-danger fw-bold" }
const _hoisted_95 = { class: "stat-item" }
const _hoisted_96 = { class: "stat-value text-success fw-bold" }
const _hoisted_97 = { class: "stat-item" }
const _hoisted_98 = { class: "stat-value text-muted fw-bold" }
const _hoisted_99 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_100 = { class: "table-responsive" }
const _hoisted_101 = { class: "table table-hover table-sm align-middle" }
const _hoisted_102 = { class: "fw-semibold" }
const _hoisted_103 = { class: "text-center" }
const _hoisted_104 = { class: "badge bg-primary" }
const _hoisted_105 = { class: "text-center" }
const _hoisted_106 = { class: "badge bg-success" }
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = { class: "badge bg-danger" }
const _hoisted_109 = { class: "text-end text-primary fw-bold" }
const _hoisted_110 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_111 = { class: "table-responsive" }
const _hoisted_112 = { class: "table table-hover table-striped align-middle" }
const _hoisted_113 = { class: "fw-semibold" }
const _hoisted_114 = {
  class: "fw-bold",
  style: {"color":"#3e5fce"}
}
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { class: "card-body p-4" }
const _hoisted_117 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_118 = { class: "card-title text-dark mb-0" }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = { class: "row g-3" }
const _hoisted_121 = { class: "col-md-3" }
const _hoisted_122 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_123 = { class: "stat-item" }
const _hoisted_124 = { class: "stat-value fw-bold" }
const _hoisted_125 = { class: "stat-item" }
const _hoisted_126 = { class: "stat-value fw-bold" }
const _hoisted_127 = { class: "stat-item" }
const _hoisted_128 = { class: "stat-value fw-bold" }
const _hoisted_129 = { class: "stat-item" }
const _hoisted_130 = { class: "stat-value text-success fw-bold" }
const _hoisted_131 = { class: "col-md-3" }
const _hoisted_132 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_133 = { class: "stat-item" }
const _hoisted_134 = { class: "stat-value badge bg-primary" }
const _hoisted_135 = { class: "stat-item" }
const _hoisted_136 = { class: "stat-value badge bg-success" }
const _hoisted_137 = { class: "stat-item" }
const _hoisted_138 = { class: "stat-value badge bg-danger" }
const _hoisted_139 = { class: "stat-item" }
const _hoisted_140 = { class: "stat-value badge bg-warning text-dark" }
const _hoisted_141 = { class: "col-md-3" }
const _hoisted_142 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_143 = { class: "stat-item" }
const _hoisted_144 = { class: "stat-value text-primary fw-bold" }
const _hoisted_145 = { class: "stat-item" }
const _hoisted_146 = { class: "stat-value text-success fw-bold" }
const _hoisted_147 = { class: "stat-item" }
const _hoisted_148 = { class: "stat-value text-danger fw-bold" }
const _hoisted_149 = { class: "col-md-3" }
const _hoisted_150 = { class: "stats-card bg-light p-3 rounded" }
const _hoisted_151 = { class: "stat-item" }
const _hoisted_152 = { class: "stat-value" }
const _hoisted_153 = {
  class: "progress",
  style: {"height":"20px"}
}
const _hoisted_154 = ["aria-valuenow"]
const _hoisted_155 = { class: "stat-item" }
const _hoisted_156 = { class: "stat-value text-info fw-bold" }
const _hoisted_157 = { class: "stat-item" }
const _hoisted_158 = { class: "stat-value badge bg-secondary" }
const _hoisted_159 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_160 = { class: "table-responsive" }
const _hoisted_161 = { class: "table table-hover table-striped align-middle" }
const _hoisted_162 = {
  class: "fw-bold",
  style: {"color":"#3e5fce"}
}
const _hoisted_163 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_164 = {
  key: 3,
  class: "text-center py-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                _createElementVNode("h4", { class: "mb-0" }, [
                  _createElementVNode("i", { class: "fa fa-chart-bar me-2" }),
                  _createTextVNode("Advance Salary Reports")
                ]),
                _createElementVNode("small", { class: "opacity-75" }, "Comprehensive reporting and analytics")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-calendar me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.getCurrentDate()), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[28] || (_cache[28] = _createElementVNode("h6", {
                class: "mb-3",
                style: {"color":"#3e5fce"}
              }, [
                _createElementVNode("i", { class: "fa fa-filter me-2" }),
                _createTextVNode("Report Filters")
              ], -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                    _createElementVNode("i", { class: "fa fa-file-text-o me-1" }),
                    _createTextVNode("Report Type "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.reportType) = $event)),
                    class: "form-select form-select-lg shadow-sm",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onReportTypeChange && _ctx.onReportTypeChange(...args)))
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("option", { value: "" }, "Select Report Type", -1),
                    _createElementVNode("option", { value: "manager" }, "👔 Manager-wise", -1),
                    _createElementVNode("option", { value: "site" }, "🏢 Site-wise", -1),
                    _createElementVNode("option", { value: "employee" }, "👤 Employee-wise", -1)
                  ]))], 544), [
                    [_vModelSelect, _ctx.filters.reportType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                    _createElementVNode("i", { class: "fa fa-calendar-check-o me-1" }),
                    _createTextVNode("Start Date ")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.startDate) = $event)),
                    class: "form-control form-control-lg shadow-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.filters.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                    _createElementVNode("i", { class: "fa fa-calendar-times-o me-1" }),
                    _createTextVNode("End Date ")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.endDate) = $event)),
                    class: "form-control form-control-lg shadow-sm"
                  }, null, 512), [
                    [_vModelText, _ctx.filters.endDate]
                  ])
                ]),
                (_ctx.filters.reportType === 'manager')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                        _createElementVNode("i", { class: "fa fa-user-tie me-1" }),
                        _createTextVNode("Manager ")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.managerId) = $event)),
                        class: "form-select form-select-lg shadow-sm"
                      }, [
                        _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "All Managers", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managers, (manager) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: manager._id,
                            value: manager._id
                          }, _toDisplayString(manager.employeeName), 9, _hoisted_16))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.managerId]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.filters.reportType === 'site' || _ctx.filters.reportType === 'employee')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                        _createElementVNode("i", { class: "fa fa-building-o me-1" }),
                        _createTextVNode("Site ")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.siteId) = $event)),
                        class: "form-select form-select-lg shadow-sm"
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "All Sites", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: site._id,
                            value: site._id
                          }, _toDisplayString(site.siteName), 9, _hoisted_18))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.siteId]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.filters.reportType === 'employee')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                        _createElementVNode("i", { class: "fa fa-user me-1" }),
                        _createTextVNode("Employee ")
                      ], -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.employeeId) = $event)),
                        class: "form-select form-select-lg shadow-sm"
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "All Employees", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: employee._id,
                            value: employee._id
                          }, _toDisplayString(employee.employeeName) + " - " + _toDisplayString(employee.employeeCode), 9, _hoisted_20))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.filters.employeeId]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                    _createElementVNode("i", { class: "fa fa-info-circle me-1" }),
                    _createTextVNode("Status ")
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.status) = $event)),
                    class: "form-select form-select-lg shadow-sm"
                  }, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "Pending" }, "⏳ Pending", -1),
                    _createElementVNode("option", { value: "Approved" }, "✅ Approved", -1),
                    _createElementVNode("option", { value: "Rejected" }, "❌ Rejected", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.filters.status]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                    _createElementVNode("i", { class: "fa fa-sitemap me-1" }),
                    _createTextVNode("Department ")
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.departmentId) = $event)),
                    class: "form-select form-select-lg shadow-sm"
                  }, [
                    _cache[26] || (_cache[26] = _createElementVNode("option", { value: "" }, "All Departments", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (dept) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: dept._id,
                        value: dept._id
                      }, _toDisplayString(dept.name), 9, _hoisted_23))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.departmentId]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fetchReport && _ctx.fetchReport(...args))),
                  class: "btn btn-lg px-4 shadow custom-btn-primary",
                  disabled: _ctx.loading || !_ctx.filters.reportType
                }, [...(_cache[29] || (_cache[29] = [
                  _createElementVNode("i", { class: "fa fa-search me-2" }, null, -1),
                  _createTextVNode(" Generate Report ", -1)
                ]))], 8, _hoisted_26),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
                  class: "btn btn-lg px-4 shadow custom-btn-success",
                  disabled: !_ctx.reportData || _ctx.loading
                }, [...(_cache[30] || (_cache[30] = [
                  _createElementVNode("i", { class: "fa fa-file-excel-o me-2" }, null, -1),
                  _createTextVNode(" Export to Excel ", -1)
                ]))], 8, _hoisted_27),
                _createElementVNode("button", {
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
                  class: "btn btn-lg px-4 shadow-sm custom-btn-outline"
                }, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("i", { class: "fa fa-refresh me-2" }, null, -1),
                  _createTextVNode(" Reset Filters ", -1)
                ]))])
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("div", { class: "loading-container" }, [
                    _createElementVNode("div", {
                      class: "spinner-border",
                      role: "status",
                      style: {"width":"3rem","height":"3rem","color":"#3e5fce"}
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ]),
                    _createElementVNode("p", { class: "mt-3 text-muted fw-semibold" }, "Generating your report...")
                  ], -1)
                ]))]))
              : (_ctx.reportData && _ctx.reportData.data && _ctx.reportData.data.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_ctx.reportData.reportType === 'manager')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "report-header mb-4" }, [
                            _createElementVNode("h5", { style: {"color":"#3e5fce"} }, [
                              _createElementVNode("i", { class: "fa fa-user-tie me-2" }),
                              _createTextVNode("Manager-wise Report")
                            ]),
                            _createElementVNode("hr", { class: "divider" })
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData.data, (manager, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "card mb-4 shadow-sm border-0 report-card"
                            }, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("h5", _hoisted_33, [
                                    _cache[33] || (_cache[33] = _createElementVNode("i", {
                                      class: "fa fa-user-circle me-2",
                                      style: {"color":"#3e5fce"}
                                    }, null, -1)),
                                    _createTextVNode(_toDisplayString(manager.managerName), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm px-3 custom-btn-outline",
                                    onClick: ($event: any) => (_ctx.toggleRequests(index))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(_ctx.showRequests[index] ? 'fa fa-eye-slash' : 'fa fa-eye')
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(_ctx.showRequests[index] ? 'Hide' : 'Show') + " Details ", 1)
                                  ], 8, _hoisted_34)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                      _cache[38] || (_cache[38] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-file-text-o me-2" }),
                                        _createTextVNode("Request Statistics")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_38, [
                                        _cache[34] || (_cache[34] = _createElementVNode("span", { class: "stat-label" }, "Total Requests:", -1)),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(manager.totalRequests), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_40, [
                                        _cache[35] || (_cache[35] = _createElementVNode("span", { class: "stat-label" }, "Approved:", -1)),
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(manager.approvedCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_42, [
                                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "stat-label" }, "Rejected:", -1)),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(manager.rejectedCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_44, [
                                        _cache[37] || (_cache[37] = _createElementVNode("span", { class: "stat-label" }, "Pending:", -1)),
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(manager.pendingCount), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _cache[42] || (_cache[42] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-money me-2" }),
                                        _createTextVNode("Amount Details")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_48, [
                                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "stat-label" }, "Total Requested:", -1)),
                                        _createElementVNode("span", _hoisted_49, "₹" + _toDisplayString(_ctx.formatAmount(manager.totalAmountRequested)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_50, [
                                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "stat-label" }, "Total Approved:", -1)),
                                        _createElementVNode("span", _hoisted_51, "₹" + _toDisplayString(_ctx.formatAmount(manager.totalAmountApproved)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_52, [
                                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "stat-label" }, "Total Rejected:", -1)),
                                        _createElementVNode("span", _hoisted_53, "₹" + _toDisplayString(_ctx.formatAmount(manager.totalAmountRejected)), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _cache[46] || (_cache[46] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-line-chart me-2" }),
                                        _createTextVNode("Key Metrics")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_56, [
                                        _cache[43] || (_cache[43] = _createElementVNode("span", { class: "stat-label" }, "Critical Requests:", -1)),
                                        _createElementVNode("span", _hoisted_57, _toDisplayString(manager.criticalRequestCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _cache[44] || (_cache[44] = _createElementVNode("span", { class: "stat-label" }, "Avg Request Amount:", -1)),
                                        _createElementVNode("span", _hoisted_59, "₹" + _toDisplayString(_ctx.formatAmount(manager.averageRequestAmount)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_60, [
                                        _cache[45] || (_cache[45] = _createElementVNode("span", { class: "stat-label" }, "Approval Rate:", -1)),
                                        _createElementVNode("span", _hoisted_61, [
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-success",
                                              role: "progressbar",
                                              style: _normalizeStyle({width: manager.approvalRate + '%'}),
                                              "aria-valuenow": manager.approvalRate,
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(manager.approvalRate) + "% ", 13, _hoisted_63)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ]),
                                (_ctx.showRequests[index])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                      _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("table", _hoisted_66, [
                                          _cache[47] || (_cache[47] = _createElementVNode("thead", { class: "custom-table-header" }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-user me-1" }),
                                                _createTextVNode("Employee Name")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-money me-1" }),
                                                _createTextVNode("Amount")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-info-circle me-1" }),
                                                _createTextVNode("Status")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-calendar me-1" }),
                                                _createTextVNode("Date")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-comment me-1" }),
                                                _createTextVNode("Reason")
                                              ])
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(manager.requests, (req, idx) => {
                                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                _createElementVNode("td", _hoisted_67, _toDisplayString(req.employeeName), 1),
                                                _createElementVNode("td", _hoisted_68, "₹" + _toDisplayString(_ctx.formatAmount(req.amount)), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(_ctx.getStatusClass(req.status))
                                                  }, _toDisplayString(req.status), 3)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(req.date)), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("small", null, _toDisplayString(req.reason), 1)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.reportData.reportType === 'site')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _cache[66] || (_cache[66] = _createElementVNode("div", { class: "report-header mb-4" }, [
                            _createElementVNode("h5", { style: {"color":"#3e5fce"} }, [
                              _createElementVNode("i", { class: "fa fa-building-o me-2" }),
                              _createTextVNode("Site-wise Report")
                            ]),
                            _createElementVNode("hr", { class: "divider" })
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData.data, (site, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "card mb-4 shadow-sm border-0 report-card"
                            }, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, [
                                  _createElementVNode("h5", _hoisted_72, [
                                    _cache[49] || (_cache[49] = _createElementVNode("i", {
                                      class: "fa fa-map-marker me-2",
                                      style: {"color":"#3e5fce"}
                                    }, null, -1)),
                                    _createTextVNode(_toDisplayString(site.siteName), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm px-3 custom-btn-outline",
                                    onClick: ($event: any) => (_ctx.toggleRequests(index))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(_ctx.showRequests[index] ? 'fa fa-eye-slash' : 'fa fa-eye')
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(_ctx.showRequests[index] ? 'Hide' : 'Show') + " Details ", 1)
                                  ], 8, _hoisted_73)
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      _cache[55] || (_cache[55] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-users me-2" }),
                                        _createTextVNode("Site Overview")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_77, [
                                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "stat-label" }, "Total Requests:", -1)),
                                        _createElementVNode("span", _hoisted_78, _toDisplayString(site.totalRequests), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_79, [
                                        _cache[51] || (_cache[51] = _createElementVNode("span", { class: "stat-label" }, "Employee Count:", -1)),
                                        _createElementVNode("span", _hoisted_80, _toDisplayString(site.employeeCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_81, [
                                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "stat-label" }, "Approved:", -1)),
                                        _createElementVNode("span", _hoisted_82, _toDisplayString(site.approvedCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_83, [
                                        _cache[53] || (_cache[53] = _createElementVNode("span", { class: "stat-label" }, "Rejected:", -1)),
                                        _createElementVNode("span", _hoisted_84, _toDisplayString(site.rejectedCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_85, [
                                        _cache[54] || (_cache[54] = _createElementVNode("span", { class: "stat-label" }, "Pending:", -1)),
                                        _createElementVNode("span", _hoisted_86, _toDisplayString(site.pendingCount), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("div", _hoisted_88, [
                                      _cache[61] || (_cache[61] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-rupee me-2" }),
                                        _createTextVNode("Financial Summary")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_89, [
                                        _cache[56] || (_cache[56] = _createElementVNode("span", { class: "stat-label" }, "Total Requested:", -1)),
                                        _createElementVNode("span", _hoisted_90, "₹" + _toDisplayString(_ctx.formatAmount(site.totalAmountRequested)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_91, [
                                        _cache[57] || (_cache[57] = _createElementVNode("span", { class: "stat-label" }, "Total Approved:", -1)),
                                        _createElementVNode("span", _hoisted_92, "₹" + _toDisplayString(_ctx.formatAmount(site.totalAmountApproved)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_93, [
                                        _cache[58] || (_cache[58] = _createElementVNode("span", { class: "stat-label" }, "Total Rejected:", -1)),
                                        _createElementVNode("span", _hoisted_94, "₹" + _toDisplayString(_ctx.formatAmount(site.totalAmountRejected)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_95, [
                                        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "stat-label" }, "Highest Amount:", -1)),
                                        _createElementVNode("span", _hoisted_96, "₹" + _toDisplayString(_ctx.formatAmount(site.highestAmount)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_97, [
                                        _cache[60] || (_cache[60] = _createElementVNode("span", { class: "stat-label" }, "Lowest Amount:", -1)),
                                        _createElementVNode("span", _hoisted_98, "₹" + _toDisplayString(_ctx.formatAmount(site.lowestAmount)), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                (site.departments && site.departments.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                      _cache[63] || (_cache[63] = _createElementVNode("h6", {
                                        class: "mb-3",
                                        style: {"color":"#3e5fce"}
                                      }, [
                                        _createElementVNode("i", { class: "fa fa-sitemap me-2" }),
                                        _createTextVNode("Department Breakdown")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_100, [
                                        _createElementVNode("table", _hoisted_101, [
                                          _cache[62] || (_cache[62] = _createElementVNode("thead", { class: "table-light" }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("th", null, "Department"),
                                              _createElementVNode("th", { class: "text-center" }, "Requests"),
                                              _createElementVNode("th", { class: "text-center" }, "Approved"),
                                              _createElementVNode("th", { class: "text-center" }, "Rejected"),
                                              _createElementVNode("th", { class: "text-end" }, "Total Amount")
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(site.departments, (dept, idx) => {
                                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                _createElementVNode("td", _hoisted_102, _toDisplayString(dept.departmentName), 1),
                                                _createElementVNode("td", _hoisted_103, [
                                                  _createElementVNode("span", _hoisted_104, _toDisplayString(dept.requestCount), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_105, [
                                                  _createElementVNode("span", _hoisted_106, _toDisplayString(dept.approvedCount), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_107, [
                                                  _createElementVNode("span", _hoisted_108, _toDisplayString(dept.rejectedCount), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_109, "₹" + _toDisplayString(_ctx.formatAmount(dept.totalAmount)), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.showRequests[index])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                      _cache[65] || (_cache[65] = _createElementVNode("h6", {
                                        class: "mb-3",
                                        style: {"color":"#3e5fce"}
                                      }, [
                                        _createElementVNode("i", { class: "fa fa-list me-2" }),
                                        _createTextVNode("Detailed Requests")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_111, [
                                        _createElementVNode("table", _hoisted_112, [
                                          _cache[64] || (_cache[64] = _createElementVNode("thead", { class: "custom-table-header" }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-user me-1" }),
                                                _createTextVNode("Employee Name")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-sitemap me-1" }),
                                                _createTextVNode("Department")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-money me-1" }),
                                                _createTextVNode("Amount")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-info-circle me-1" }),
                                                _createTextVNode("Status")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-calendar me-1" }),
                                                _createTextVNode("Date")
                                              ])
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(site.requests, (req, idx) => {
                                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                _createElementVNode("td", _hoisted_113, _toDisplayString(req.employeeName), 1),
                                                _createElementVNode("td", null, _toDisplayString(req.department), 1),
                                                _createElementVNode("td", _hoisted_114, "₹" + _toDisplayString(_ctx.formatAmount(req.amount)), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(_ctx.getStatusClass(req.status))
                                                  }, _toDisplayString(req.status), 3)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(req.date)), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.reportData.reportType === 'employee')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _cache[88] || (_cache[88] = _createElementVNode("div", { class: "report-header mb-4" }, [
                            _createElementVNode("h5", { style: {"color":"#3e5fce"} }, [
                              _createElementVNode("i", { class: "fa fa-user me-2" }),
                              _createTextVNode("Employee-wise Report")
                            ]),
                            _createElementVNode("hr", { class: "divider" })
                          ], -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData.data, (employee, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "card mb-4 shadow-sm border-0 report-card"
                            }, [
                              _createElementVNode("div", _hoisted_116, [
                                _createElementVNode("div", _hoisted_117, [
                                  _createElementVNode("h5", _hoisted_118, [
                                    _cache[67] || (_cache[67] = _createElementVNode("i", {
                                      class: "fa fa-id-badge me-2",
                                      style: {"color":"#3e5fce"}
                                    }, null, -1)),
                                    _createTextVNode(_toDisplayString(employee.employeeName), 1)
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm px-3 custom-btn-outline",
                                    onClick: ($event: any) => (_ctx.toggleRequests(index))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(_ctx.showRequests[index] ? 'fa fa-eye-slash' : 'fa fa-eye')
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(_ctx.showRequests[index] ? 'Hide' : 'Show') + " Details ", 1)
                                  ], 8, _hoisted_119)
                                ]),
                                _createElementVNode("div", _hoisted_120, [
                                  _createElementVNode("div", _hoisted_121, [
                                    _createElementVNode("div", _hoisted_122, [
                                      _cache[72] || (_cache[72] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-info-circle me-2" }),
                                        _createTextVNode("Employee Info")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_123, [
                                        _cache[68] || (_cache[68] = _createElementVNode("span", { class: "stat-label" }, [
                                          _createElementVNode("i", { class: "fa fa-building-o me-1" }),
                                          _createTextVNode("Site:")
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_124, _toDisplayString(employee.site), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_125, [
                                        _cache[69] || (_cache[69] = _createElementVNode("span", { class: "stat-label" }, [
                                          _createElementVNode("i", { class: "fa fa-sitemap me-1" }),
                                          _createTextVNode("Department:")
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_126, _toDisplayString(employee.department), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_127, [
                                        _cache[70] || (_cache[70] = _createElementVNode("span", { class: "stat-label" }, [
                                          _createElementVNode("i", { class: "fa fa-briefcase me-1" }),
                                          _createTextVNode("Designation:")
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_128, _toDisplayString(employee.designation), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_129, [
                                        _cache[71] || (_cache[71] = _createElementVNode("span", { class: "stat-label" }, [
                                          _createElementVNode("i", { class: "fa fa-money me-1" }),
                                          _createTextVNode("Salary:")
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_130, "₹" + _toDisplayString(_ctx.formatAmount(employee.salary)), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_131, [
                                    _createElementVNode("div", _hoisted_132, [
                                      _cache[77] || (_cache[77] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-file-text-o me-2" }),
                                        _createTextVNode("Request Stats")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_133, [
                                        _cache[73] || (_cache[73] = _createElementVNode("span", { class: "stat-label" }, "Total Requests:", -1)),
                                        _createElementVNode("span", _hoisted_134, _toDisplayString(employee.totalRequests), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_135, [
                                        _cache[74] || (_cache[74] = _createElementVNode("span", { class: "stat-label" }, "Approved:", -1)),
                                        _createElementVNode("span", _hoisted_136, _toDisplayString(employee.approvedCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_137, [
                                        _cache[75] || (_cache[75] = _createElementVNode("span", { class: "stat-label" }, "Rejected:", -1)),
                                        _createElementVNode("span", _hoisted_138, _toDisplayString(employee.rejectedCount), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_139, [
                                        _cache[76] || (_cache[76] = _createElementVNode("span", { class: "stat-label" }, "Pending:", -1)),
                                        _createElementVNode("span", _hoisted_140, _toDisplayString(employee.pendingCount), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_141, [
                                    _createElementVNode("div", _hoisted_142, [
                                      _cache[81] || (_cache[81] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-rupee me-2" }),
                                        _createTextVNode("Amount Summary")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_143, [
                                        _cache[78] || (_cache[78] = _createElementVNode("span", { class: "stat-label" }, "Total Requested:", -1)),
                                        _createElementVNode("span", _hoisted_144, "₹" + _toDisplayString(_ctx.formatAmount(employee.totalAmountRequested)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_145, [
                                        _cache[79] || (_cache[79] = _createElementVNode("span", { class: "stat-label" }, "Total Approved:", -1)),
                                        _createElementVNode("span", _hoisted_146, "₹" + _toDisplayString(_ctx.formatAmount(employee.totalAmountApproved)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_147, [
                                        _cache[80] || (_cache[80] = _createElementVNode("span", { class: "stat-label" }, "Total Rejected:", -1)),
                                        _createElementVNode("span", _hoisted_148, "₹" + _toDisplayString(_ctx.formatAmount(employee.totalAmountRejected)), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_149, [
                                    _createElementVNode("div", _hoisted_150, [
                                      _cache[85] || (_cache[85] = _createElementVNode("h6", { class: "text-muted mb-3" }, [
                                        _createElementVNode("i", { class: "fa fa-line-chart me-2" }),
                                        _createTextVNode("Analytics")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_151, [
                                        _cache[82] || (_cache[82] = _createElementVNode("span", { class: "stat-label" }, "Rejection Rate:", -1)),
                                        _createElementVNode("span", _hoisted_152, [
                                          _createElementVNode("div", _hoisted_153, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-danger",
                                              role: "progressbar",
                                              style: _normalizeStyle({width: employee.rejectionRate + '%'}),
                                              "aria-valuenow": employee.rejectionRate,
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(employee.rejectionRate) + "% ", 13, _hoisted_154)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_155, [
                                        _cache[83] || (_cache[83] = _createElementVNode("span", { class: "stat-label" }, "Avg Amount:", -1)),
                                        _createElementVNode("span", _hoisted_156, "₹" + _toDisplayString(_ctx.formatAmount(employee.averageRequestAmount)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_157, [
                                        _cache[84] || (_cache[84] = _createElementVNode("span", { class: "stat-label" }, "Last Request:", -1)),
                                        _createElementVNode("span", _hoisted_158, _toDisplayString(_ctx.formatDate(employee.lastRequestDate)), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                (_ctx.showRequests[index])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                      _cache[87] || (_cache[87] = _createElementVNode("h6", {
                                        class: "mb-3",
                                        style: {"color":"#3e5fce"}
                                      }, [
                                        _createElementVNode("i", { class: "fa fa-list me-2" }),
                                        _createTextVNode("Request History")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_160, [
                                        _createElementVNode("table", _hoisted_161, [
                                          _cache[86] || (_cache[86] = _createElementVNode("thead", { class: "custom-table-header" }, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-money me-1" }),
                                                _createTextVNode("Amount")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-info-circle me-1" }),
                                                _createTextVNode("Status")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-calendar me-1" }),
                                                _createTextVNode("Date")
                                              ]),
                                              _createElementVNode("th", null, [
                                                _createElementVNode("i", { class: "fa fa-comment me-1" }),
                                                _createTextVNode("Reason")
                                              ])
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employee.requests, (req, idx) => {
                                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                _createElementVNode("td", _hoisted_162, "₹" + _toDisplayString(_ctx.formatAmount(req.amount)), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(_ctx.getStatusClass(req.status))
                                                  }, _toDisplayString(req.status), 3)
                                                ]),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(req.date)), 1),
                                                _createElementVNode("td", null, [
                                                  _createElementVNode("small", null, _toDisplayString(req.reason), 1)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (!_ctx.loading && _ctx.reportData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [...(_cache[89] || (_cache[89] = [
                      _createElementVNode("div", { class: "empty-state" }, [
                        _createElementVNode("i", { class: "fa fa-inbox fa-5x text-muted mb-3" }),
                        _createElementVNode("h5", { class: "text-muted" }, "No Data Available"),
                        _createElementVNode("p", { class: "text-secondary" }, "No records found for the selected filters. Try adjusting your search criteria.")
                      ], -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_164, [...(_cache[90] || (_cache[90] = [
                      _createElementVNode("div", { class: "initial-state" }, [
                        _createElementVNode("i", {
                          class: "fa fa-bar-chart fa-5x mb-3",
                          style: {"color":"#3e5fce"}
                        }),
                        _createElementVNode("h5", { style: {"color":"#3e5fce"} }, "Ready to Generate Report"),
                        _createElementVNode("p", { class: "text-secondary" }, "Select a report type and click \"Generate Report\" to view comprehensive analytics.")
                      ], -1)
                    ]))]))
          ])
        ])
      ])
    ])
  ]))
}